import { useEffect, useState } from "react";
import api from "@/lib/api";

const SETTORI = ["INFANZIA", "PRIMARIA", "SECONDARIA"];

const todayYY = () => {
  const d = new Date();
  return d.getMonth() >= 8 ? d.getFullYear() : d.getFullYear() - 1;
};

export default function ExtraListinoPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterAnno, setFilterAnno] = useState(todayYY());
  const [filterSettore, setFilterSettore] = useState("");
  const [edit, setEdit] = useState(null); // record in editing o {} per nuovo
  const [saving, setSaving] = useState(false);

  const carica = async () => {
    setLoading(true);
    try {
      const params = { anno: filterAnno };
      if (filterSettore) params.settore = filterSettore;
      const r = await api.get("/extra-listino/", { params });
      setItems(r.data?.items || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { carica(); /* eslint-disable-next-line */ }, [filterAnno, filterSettore]);

  const nuovo = () => setEdit({
    anno: filterAnno, settore: filterSettore || "PRIMARIA",
    descrizione: "", classi: "TUTTE", nr_giorni: 1,
    cosa_puo_scegliere: "", importo_rata: 0, rate: [{ nome: "ISCRIZIONE", scadenza: "" }],
    attivo: true, ordine: 0, note: "",
  });

  const salva = async () => {
    setSaving(true);
    try {
      const body = { ...edit };
      body.anno = Number(body.anno);
      body.nr_giorni = Number(body.nr_giorni || 1);
      body.importo_rata = Number(body.importo_rata || 0);
      body.ordine = Number(body.ordine || 0);
      body.rate = (body.rate || []).filter(r => r.nome).map(r => ({ nome: r.nome, scadenza: r.scadenza || null }));
      if (edit.id) await api.put(`/extra-listino/${edit.id}`, body);
      else await api.post("/extra-listino/", body);
      setEdit(null);
      carica();
    } catch (e) {
      alert("Errore: " + (e.response?.data?.detail || e.message));
    } finally { setSaving(false); }
  };

  const elimina = async (it) => {
    if (!window.confirm(`Eliminare "${it.descrizione}" (${it.settore} · ${it.nr_giorni}gg)?`)) return;
    try {
      await api.delete(`/extra-listino/${it.id}`);
      carica();
    } catch (e) {
      alert("Errore: " + (e.response?.data?.detail || e.message));
    }
  };

  return (
    <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>
      <div style={{ background: "linear-gradient(90deg,#1565c0,#0d47a1)", color: "white", padding: "14px 22px", fontSize: 16, fontWeight: 800, letterSpacing: 0.5 }}>
        📋 LISTINO CORSI EXTRA
      </div>
      <div style={{ padding: "12px 20px", background: "white", display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", borderBottom: "1px solid #ddd" }}>
        <div>
          <label style={{ fontSize: 10, color: "#666", display: "block" }}>ANNO SCOL.</label>
          <input type="number" value={filterAnno} onChange={e => setFilterAnno(Number(e.target.value))}
            data-testid="lst-filter-anno"
            style={{ width: 90, padding: 5, border: "1px solid #ccc", fontSize: 12 }} />
        </div>
        <div>
          <label style={{ fontSize: 10, color: "#666", display: "block" }}>SETTORE</label>
          <select value={filterSettore} onChange={e => setFilterSettore(e.target.value)}
            data-testid="lst-filter-settore"
            style={{ width: 140, padding: 5, border: "1px solid #ccc", fontSize: 12 }}>
            <option value="">— Tutti —</option>
            {SETTORI.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div style={{ flex: 1 }} />
        <button onClick={nuovo} data-testid="lst-nuovo"
          style={{ padding: "8px 16px", background: "#1565c0", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: "pointer", letterSpacing: 0.3 }}>
          ➕ NUOVO CORSO
        </button>
        <label data-testid="lst-import-label"
          style={{ padding: "8px 16px", background: "#558b2f", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: "pointer", letterSpacing: 0.3 }}>
          📥 IMPORTA EXCEL
          <input type="file" accept=".xlsx" onChange={async (e) => {
            const f = e.target.files?.[0]; if (!f) return;
            const fd = new FormData(); fd.append("file", f);
            try {
              const r = await api.post("/extra-listino/import-excel", fd, { headers: { "Content-Type": "multipart/form-data" } });
              alert(`✓ Importate ${r.data.inserted} nuove voci, aggiornate ${r.data.updated}, saltate ${r.data.skipped}.`);
              e.target.value = ""; carica();
            } catch (err) {
              alert("Errore: " + (err.response?.data?.detail || err.message));
              e.target.value = "";
            }
          }} style={{ display: "none" }} />
        </label>
        <div style={{ color: "#888", fontSize: 12 }}><b>{items.length}</b> voci</div>
      </div>

      <div style={{ padding: 14 }}>
        {loading && <div style={{ textAlign: "center", padding: 30, color: "#888" }}>Caricamento…</div>}
        {!loading && items.length === 0 && (
          <div style={{ textAlign: "center", padding: 30, color: "#888", fontStyle: "italic", background: "white", border: "1px dashed #ccc" }}>
            Nessuna voce di listino. Clicca "➕ Nuovo Corso" per iniziare.
          </div>
        )}
        {!loading && items.length > 0 && (
          <table className="sw-table sw-table-compact" style={{ fontSize: 11, width: "100%", background: "white" }}>
            <thead>
              <tr style={{ background: "#37474f", color: "white" }}>
                <th style={{ width: 60 }}>ANNO</th>
                <th style={{ width: 110 }}>SETTORE</th>
                <th>DESCRIZIONE</th>
                <th style={{ width: 90 }}>CLASSI</th>
                <th style={{ width: 50, textAlign: "center" }}>GG</th>
                <th>COSA PUÒ SCEGLIERE</th>
                <th style={{ width: 90, textAlign: "right" }}>IMPORTO €</th>
                <th>RATE</th>
                <th style={{ width: 60, textAlign: "center" }}>ATTIVO</th>
                <th style={{ width: 100, textAlign: "center" }}>AZIONI</th>
              </tr>
            </thead>
            <tbody>
              {items.map(it => (
                <tr key={it.id} data-testid={`lst-row-${it.id}`} style={{ borderTop: "1px solid #eee" }}>
                  <td style={{ fontFamily: "monospace", fontWeight: 700 }}>{it.anno}</td>
                  <td style={{ fontWeight: 700, color: "#1565c0" }}>{it.settore}</td>
                  <td style={{ fontWeight: 700 }}>{it.descrizione}</td>
                  <td>{it.classi}</td>
                  <td style={{ textAlign: "center", fontFamily: "monospace", fontWeight: 800 }}>{it.nr_giorni}</td>
                  <td style={{ fontSize: 10 }}>{it.cosa_puo_scegliere}</td>
                  <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700, color: "#1b5e20" }}>
                    € {Number(it.importo_rata || 0).toLocaleString("it-IT", { minimumFractionDigits: 2 })}
                  </td>
                  <td style={{ fontSize: 9 }}>
                    {(it.rate || []).map((r, i) => (
                      <div key={i} style={{ whiteSpace: "nowrap" }}>
                        <b>{r.nome}</b>{r.scadenza ? ` · ${r.scadenza}` : ""}
                      </div>
                    ))}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {it.attivo ? <span style={{ color: "#1b5e20", fontWeight: 800 }}>✓</span> : <span style={{ color: "#c62828" }}>✕</span>}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <button onClick={() => setEdit({ ...it })} data-testid={`lst-edit-${it.id}`}
                      style={{ padding: "3px 8px", background: "#1565c0", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 4 }}>✎</button>
                    <button onClick={() => elimina(it)} data-testid={`lst-del-${it.id}`}
                      style={{ padding: "3px 8px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {edit && (
        <div onClick={() => setEdit(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 700, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div onClick={e => e.stopPropagation()} data-testid="lst-edit-modal"
            style={{ background: "white", width: "100%", maxWidth: 720, borderRadius: 4, overflow: "hidden" }}>
            <div style={{ background: "#1565c0", color: "white", padding: "12px 18px", display: "flex", justifyContent: "space-between" }}>
              <div style={{ fontSize: 15, fontWeight: 800 }}>{edit.id ? "✎ MODIFICA VOCE LISTINO" : "➕ NUOVA VOCE LISTINO"}</div>
              <button onClick={() => setEdit(null)} style={{ background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: 18, maxHeight: "70vh", overflow: "auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <Field label="ANNO *">
                <input type="number" value={edit.anno || ""} onChange={e => setEdit({ ...edit, anno: e.target.value })} data-testid="lst-fld-anno" style={inp} />
              </Field>
              <Field label="SETTORE *">
                <select value={edit.settore || "PRIMARIA"} onChange={e => setEdit({ ...edit, settore: e.target.value })} data-testid="lst-fld-settore" style={inp}>
                  {SETTORI.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </Field>
              <Field label="DESCRIZIONE *" wide>
                <input type="text" value={edit.descrizione || ""} onChange={e => setEdit({ ...edit, descrizione: e.target.value.toUpperCase() })} data-testid="lst-fld-descr" style={inp} placeholder="es. DOPOSCUOLA" />
              </Field>
              <Field label="CLASSI">
                <input type="text" value={edit.classi || ""} onChange={e => setEdit({ ...edit, classi: e.target.value.toUpperCase() })} data-testid="lst-fld-classi" style={inp} placeholder="TUTTE, V, III E IV" />
              </Field>
              <Field label="NR GIORNI">
                <input type="number" value={edit.nr_giorni ?? 1} onChange={e => setEdit({ ...edit, nr_giorni: e.target.value })} data-testid="lst-fld-gg" style={inp} />
              </Field>
              <Field label="COSA PUÒ SCEGLIERE" wide>
                <input type="text" value={edit.cosa_puo_scegliere || ""} onChange={e => setEdit({ ...edit, cosa_puo_scegliere: e.target.value.toUpperCase() })} data-testid="lst-fld-scelta" style={inp} placeholder="es. MAR E GIO, LUN MAR MER GIO VEN" />
              </Field>
              <Field label="IMPORTO RATA €">
                <input type="number" step="0.01" value={edit.importo_rata ?? 0} onChange={e => setEdit({ ...edit, importo_rata: e.target.value })} data-testid="lst-fld-importo" style={inp} />
              </Field>
              <Field label="ORDINE VISUALIZZAZIONE">
                <input type="number" value={edit.ordine ?? 0} onChange={e => setEdit({ ...edit, ordine: e.target.value })} style={inp} />
              </Field>
              <div style={{ gridColumn: "1 / span 2", borderTop: "1px solid #eee", paddingTop: 10, marginTop: 4 }}>
                <div style={{ fontSize: 11, fontWeight: 800, color: "#666", marginBottom: 6, letterSpacing: 0.3 }}>RATE PAGAMENTO</div>
                {(edit.rate || []).map((r, i) => (
                  <div key={i} style={{ display: "flex", gap: 6, marginBottom: 5, alignItems: "center" }}>
                    <input type="text" value={r.nome || ""} placeholder="Nome rata (es. ISCRIZIONE, 2 RATA)"
                      onChange={e => {
                        const rate = [...edit.rate]; rate[i] = { ...rate[i], nome: e.target.value.toUpperCase() }; setEdit({ ...edit, rate });
                      }} style={{ ...inp, flex: 2 }} />
                    <input type="text" value={r.scadenza || ""} placeholder="DD/MM/YYYY"
                      onChange={e => {
                        const rate = [...edit.rate]; rate[i] = { ...rate[i], scadenza: e.target.value }; setEdit({ ...edit, rate });
                      }} style={{ ...inp, flex: 1 }} />
                    <button onClick={() => { const rate = edit.rate.filter((_, j) => j !== i); setEdit({ ...edit, rate }); }}
                      style={{ padding: "4px 8px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>✕</button>
                  </div>
                ))}
                <button onClick={() => setEdit({ ...edit, rate: [...(edit.rate || []), { nome: "", scadenza: "" }] })}
                  style={{ padding: "4px 10px", background: "#eceff1", border: "1px solid #ccc", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                  + Aggiungi rata
                </button>
              </div>
              <Field label="NOTE" wide>
                <textarea value={edit.note || ""} onChange={e => setEdit({ ...edit, note: e.target.value })} rows={2} style={{ ...inp, resize: "vertical" }} />
              </Field>
              <Field label="ATTIVO">
                <input type="checkbox" checked={!!edit.attivo} onChange={e => setEdit({ ...edit, attivo: e.target.checked })} data-testid="lst-fld-attivo" />
              </Field>
            </div>
            <div style={{ padding: "10px 18px", borderTop: "1px solid #eee", display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button onClick={() => setEdit(null)} style={{ padding: "8px 16px", background: "white", color: "#666", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
              <button onClick={salva} disabled={saving || !edit.descrizione || !edit.settore || !edit.anno}
                data-testid="lst-fld-salva"
                style={{ padding: "8px 18px", background: "#1565c0", color: "white", border: "none", fontSize: 12, fontWeight: 800, cursor: saving ? "wait" : "pointer", letterSpacing: 0.3 }}>
                {saving ? "Salvataggio..." : "✓ Salva"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const inp = { padding: 6, border: "1px solid #ccc", fontSize: 12, width: "100%" };

function Field({ label, wide, children }) {
  return (
    <div style={{ gridColumn: wide ? "1 / span 2" : undefined }}>
      <label style={{ fontSize: 10, fontWeight: 700, color: "#666", display: "block", marginBottom: 3, letterSpacing: 0.3 }}>{label}</label>
      {children}
    </div>
  );
}
